import { useState } from 'react';
import { ModalState, OverHoursValidationDetail, UnassignedRoleValidationDetail, ForecastVarianceDetail } from '../types';

/**
 * Custom hook for managing modal states
 */
export const useModalState = () => {
  const [showValidationErrorModal, setShowValidationErrorModal] = useState<boolean>(false);
  const [validationErrorTitle, setValidationErrorTitle] = useState<string>('Save Failed');
  const [validationErrorMessage, setValidationErrorMessage] = useState<string>('');
  const [showSuccessModal, setShowSuccessModal] = useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>('');
  
  // New modal states for submit validation
  const [showSubmitConfirmationModal, setShowSubmitConfirmationModal] = useState<boolean>(false);
  const [submitConfirmationMessage, setSubmitConfirmationMessage] = useState<string>('');
  const [showSubmitWarningModal, setShowSubmitWarningModal] = useState<boolean>(false);
  const [submitWarningMessage, setSubmitWarningMessage] = useState<string>('');
  const [submitWarningDetails, setSubmitWarningDetails] = useState<OverHoursValidationDetail[] | ForecastVarianceDetail[] | undefined>(undefined);
  const [showSubmitErrorModal, setShowSubmitErrorModal] = useState<boolean>(false);
  const [submitErrorMessage, setSubmitErrorMessage] = useState<string>('');
  const [submitErrorDetails, setSubmitErrorDetails] = useState<UnassignedRoleValidationDetail[] | undefined>(undefined);
  
  // Unsaved changes warning modal
  const [showUnsavedChangesModal, setShowUnsavedChangesModal] = useState<boolean>(false);
  const [unsavedChangesMessage, setUnsavedChangesMessage] = useState<string>('');

  const modalState: ModalState = {
    showValidationErrorModal,
    validationErrorTitle,
    validationErrorMessage,
    showSuccessModal,
    successMessage,
    showSubmitConfirmationModal,
    submitConfirmationMessage,
    showSubmitWarningModal,
    submitWarningMessage,
    submitWarningDetails,
    showSubmitErrorModal,
    submitErrorMessage,
    submitErrorDetails,
    showUnsavedChangesModal,
    unsavedChangesMessage
  };

  const setModalState = {
    setShowValidationErrorModal,
    setValidationErrorMessage,
    setShowSuccessModal,
    setSuccessMessage,
    setValidationErrorModal: (show: boolean, message: string, title?: string) => {
      setShowValidationErrorModal(show);
      setValidationErrorMessage(message);
      setValidationErrorTitle(title || 'Save Failed');
    },
    setSuccessModal: (show: boolean, message: string) => {
      setShowSuccessModal(show);
      setSuccessMessage(message);
    },
    setSubmitConfirmationModal: (show: boolean, message: string) => {
      setShowSubmitConfirmationModal(show);
      setSubmitConfirmationMessage(message);
    },
    setSubmitWarningModal: (show: boolean, message: string, details?: OverHoursValidationDetail[] | ForecastVarianceDetail[]) => {
      setShowSubmitWarningModal(show);
      setSubmitWarningMessage(message);
      setSubmitWarningDetails(details);
    },
    setSubmitErrorModal: (show: boolean, message: string, details?: UnassignedRoleValidationDetail[]) => {
      setShowSubmitErrorModal(show);
      setSubmitErrorMessage(message);
      setSubmitErrorDetails(details);
    },
    setUnsavedChangesModal: (show: boolean, message: string) => {
      setShowUnsavedChangesModal(show);
      setUnsavedChangesMessage(message);
    }
  };

  return {
    modalState,
    setModalState
  };
};